import { useEffect, useRef, useState } from 'react';

type Options = {
  threshold?: number;
  root?: HTMLElement;
  rootMargin?: string;
};

export const useIsInViewport = (options: Options) => {
  const [isInView, setIsInView] = useState(false);
  const targetRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsInView(entry.isIntersecting);
      },
      { ...options },
    );

    if (targetRef.current) {
      observer.observe(targetRef.current);
    }

    const target = targetRef.current;

    return () => {
      if (target) {
        observer.unobserve(target);
      }
    };
  }, [options]);

  return { targetRef, isInView };
};
